export default __webpack_public_path__ + "static/media/slide-3.c37b616b.png";